<script>
	// import { routes } from 'svelte-hash-router';
	// import Navbar from "./Navbar.svelte";
	import Chakra from "./Chakra.svelte";
	// import Home from "./Home.svelte";
	// import Projects from "./Projects.svelte";
	// import Contact from "./Contact.svelte";
	// routes.set({
	// '/': Home,
	// '/project': Projects,
	// '/contact':Contact,
	// })
</script>

<main>
	<div class="chak"><Chakra height={18}/></div>
	<div class="text"><div class="t2">Construction going on</div> <img src="https://img.icons8.com/avantgarde/344/experimental-constructing-avantgarde.png"></div>
	<!-- <Navbar/> -->
</main>

<style>
	.chak{
		display: flex;
		justify-content: center;
	}
	main{
		max-height: 100vh;
		max-width: 100vw;
		padding-top: 10rem;
		/* overflow: hidden; */
	}
	.text{
		margin-top: 1rem;
		width: 100vw;
		justify-content: center;
		font-size: 2rem;
		display: flex;
		gap: 1rem;
	}
	.t2{
		display: grid;
		place-items: center;
	}
	img{
		width: 64px;
		height: 64px;
	}
	/* :root::-webkit-scrollbar{
		width: 0.5rem;
	}
	:root::-webkit-scrollbar-track{
		background: rgba(0, 0, 0,1);
	}
	:root::-webkit-scrollbar-thumb{
		background:rgb(150, 80, 0);
	} */
</style>